// As seen in BE/adminportal/rcapp/models.py
export enum PartType {
  Miner = 'Miner',
  PowerSupply = 'Power Supply',
  ControlBoard = 'Control Board',
  Fan = 'Fan',
  Hashboard = 'Hashboard',
}

export const PartTypesShortNames: Record<PartType, string> = {
  [PartType.Miner]: 'Miner',
  [PartType.PowerSupply]: 'PSU',
  [PartType.ControlBoard]: 'CB',
  [PartType.Fan]: 'Fan',
  [PartType.Hashboard]: 'HB',
}

export const FinalPartTypes = [
  PartType.Miner,
  PartType.Fan,
  PartType.Hashboard,
  PartType.PowerSupply,
  PartType.ControlBoard,
] as string[]

// These are the ones displayed in the UI
export enum IndividualPart {
  Miner = 'Miner',
  PSU = 'PSU',
  CB = 'CB',
  FAN1 = 'Fan 1',
  FAN2 = 'Fan 2',
  FAN3 = 'Fan 3',
  FAN4 = 'Fan 4',
  HB0 = 'HB 0',
  HB1 = 'HB 1',
  HB2 = 'HB 2',
  HB3 = 'HB 3',
}

export const IndividualPartToNumber: Record<IndividualPart, number | null> = {
  [IndividualPart.Miner]: null,
  [IndividualPart.PSU]: null,
  [IndividualPart.CB]: null,
  [IndividualPart.FAN1]: 1,
  [IndividualPart.FAN2]: 2,
  [IndividualPart.FAN3]: 3,
  [IndividualPart.FAN4]: 4,
  [IndividualPart.HB0]: 0,
  [IndividualPart.HB1]: 1,
  [IndividualPart.HB2]: 2,
  [IndividualPart.HB3]: 3,
}

export const partTypes: Record<IndividualPart, PartType> = {
  [IndividualPart.Miner]: PartType.Miner,
  [IndividualPart.PSU]: PartType.PowerSupply,
  [IndividualPart.CB]: PartType.ControlBoard,
  [IndividualPart.FAN1]: PartType.Fan,
  [IndividualPart.FAN2]: PartType.Fan,
  [IndividualPart.FAN3]: PartType.Fan,
  [IndividualPart.FAN4]: PartType.Fan,
  [IndividualPart.HB0]: PartType.Hashboard,
  [IndividualPart.HB1]: PartType.Hashboard,
  [IndividualPart.HB2]: PartType.Hashboard,
  [IndividualPart.HB3]: PartType.Hashboard,
}

export const partIcons: Record<PartType, string> = {
  [PartType.Miner]: 'material-symbols:dns-outline',
  [PartType.PowerSupply]: 'material-symbols:power-outline',
  [PartType.ControlBoard]: 'material-symbols:developer-board-outline',
  [PartType.Fan]: 'material-symbols:mode-fan-outline',
  [PartType.Hashboard]: 'material-symbols:settop-component-outline',
}
